import React from 'react'

export default function Preloader({body}) {
  return (
    <div className='flex flex-col items-center'>
      <img className='!w-16 !h-16 my-2' alt='' src='/preloader.gif' />
      <div>
        {body || ''}
      </div>
    </div>
  )
}
